import { default as React, useEffect, useState } from "react";
import { connect } from "react-redux";
import { differenceInYears, format } from "date-fns";

import {
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
} from "@material-ui/core";
import { KycNotDoneDialog } from "../../customModal";
import { NEW_TRANSACTION_URL } from "..";
import {
  getCountriesList,
  getStatesList,
  storeApplicantParams,
  getKycDetails,
  checkKyc,
  getCitiesList as getCitiesByState,
  getRelationShipList,
  storePan,
  checkPAN,
} from "../../../../store/actions";
import {
  getFieldsFromMap,
  getFieldList,
  $wait,
  checkIfMinor,
} from "./lib/utils";

import CardComponent from "./lib/CardComponent";
import CustomLoader from "../../../forms/Loader";
import AutoField from "./lib/AutoField";
import {
  countryCodeRegex,
  emailRegex,
  mobileRegex,
  nameRegex,
  panRegex,
  categoryOptions,
  genderOptions,
  familyDescriptionOptions,
  relationshipOptions,
  countrycodeOptions,
} from ".";

const YES = "Yes";
const INDIVIDUAL = "individual";

const investorOptions = [
  { name: "Individual", value: INDIVIDUAL },
  { name: "Minor", value: "minor" },
];

const InvestorDetails = (props) => {
  const SINGLE_APPLICANT = "single";

  const [investortype, setInvestorType] = useState({
    investorType: INDIVIDUAL,
  });

  const MAX_APPLICANTS = 3;

  const [disabledFields, setDisabledFields] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [displayModal1, setDisplayModal1] = useState(false);
  const [displayModal2, setDisplayModal2] = useState(false);

  const [previouslyCheckedPAN, setPreviouslyCheckedPAN] = useState({
    pan_2: "",
    pan_3: "",
  });

  const validateSecondPan = (secondPan) => {
    const firstPan = formValues.pan_1;
    const thirdPan = formValues.pan_3;
    let error;
    if (firstPan === secondPan) {
      setFieldValue("pan_2", "");
      error = "PAN of the First Joint Holder should not be same as PAN 1";
      const id = document.getElementById("pan_2Field");
      id.focus();
    } else if (secondPan.length > 3 && secondPan[3] !== "P") {
      // setFieldValue("pan_2", "");
      error =
        "Entered PAN Number is not related to Individual PAN Number, So please Enter Individual PAN Number";
      const id = document.getElementById("pan_2Field");
      id.focus();
    } else if (secondPan === thirdPan) {
      setFieldValue("pan_3", "");
    } else {
      const isValid = panRegex.test(secondPan || "");
      if (!isValid) {
        error = "Please enter a valid PAN";
      }
    }
    return error;
  };

  const validateThirdPan = (thirdPan) => {
    const firstPan = formValues.pan_1;
    const secondPan = formValues.pan_2;
    let error;
    if (firstPan === thirdPan) {
      setFieldValue("pan_3", "");
      error = "PAN of the Second Joint Holder should not be same as PAN 1";
      const id = document.getElementById("pan_3Field");
      id.focus();
    } else if (secondPan === thirdPan) {
      setFieldValue("pan_3", "");
      error =
        "PAN of the Second Joint Holder should not be same as First Joint Holder";
      const id = document.getElementById("pan_3Field");
      id.focus();
    } else if (thirdPan.length > 3 && thirdPan[3] !== "P") {
      // setFieldValue("pan_3", "");
      error =
        "Entered PAN Number is not related to Individual PAN Number, So please Enter Individual PAN Number";
      const id = document.getElementById("pan_3Field");
      id.focus();
    }
    if (!!thirdPan && !panRegex.test(thirdPan)) {
      error = "Please enter a valid PAN";
    }
    return error;
  };

  const applicantSchema = {
    pan: {
      name:
        investortype.investorType != "minor"
          ? "PAN of Primary Holder"
          : "Minor PAN",
      isRequired: investortype.investorType === "minor" ? false : true,
      placeholder: "Enter PAN of First Applicant",
      validate: panRegex,
    },
    name: {
      name: investortype.investorType != "minor" ? "Name" : "Minor Name",
      isRequired: true,
      placeholder: "Enter Name",
      validate: nameRegex,
    },
    emailFamily: {
      name: "Email Family Description",
      type: "select",
      isRequired: investortype.investorType === "minor" ? false : true,
      default: "SE",
      options: familyDescriptionOptions,
    },
    email: {
      name: "Email ID",
      isRequired: investortype.investorType === "minor" ? false : true,
      placeholder: "Enter Email ID",
      validate: emailRegex,
    },
    gender: {
      name: "Gender",
      type: "select",
      isRequired: investortype.investorType === "minor" ? false : true,
      options: genderOptions,
    },
    dob: {
      name: "Date of Birth",
      type: "date",
      isRequired: true,
    },
    category: {
      name: "Category",
      type: "select",
      isRequired: investortype.investorType === "minor" ? false : true,
      options: categoryOptions,
    },
    countrycode: {
      name: "Country Code",
      isRequired: investortype.investorType === "minor" ? false : true,
      default: "+91",
      type: "select",
      options: countrycodeOptions,
    },
    mobileFamily: {
      name: "Mobile Family Description",
      type: "select",
      isRequired: investortype.investorType === "minor" ? false : true,
      default: "SE",
      options: familyDescriptionOptions,
    },
    mobile: {
      name: "Mobile Number",
      isRequired: investortype.investorType === "minor" ? false : true,
      placeholder: "Enter Mobile Number",
      validate: mobileRegex,
    },
    guardianname: {
      name: "Guardian Name",
      isRequired: true,
      placeholder: "Enter Guardian Name",
      validate: nameRegex,
      hidden: true,
    },
    guardianpan: {
      name: "Guardian PAN",
      isRequired: true,
      placeholder: "Enter PAN of First Applicant",
      validate: panRegex,
      hidden: true,
    },
    guardianemailFamily: {
      name: "Guardian Email Family Description",
      type: "select",
      isRequired: true,
      default: "SE",
      options: familyDescriptionOptions,
      hidden: true,
    },
    guardianemail: {
      name: "Guardian Email ID",
      isRequired: true,
      placeholder: "Enter Guardian Email ID",
      validate: emailRegex,
      hidden: true,
    },
    guardianmobileFamily: {
      name: "Guardian Mobile Family Description",
      type: "select",
      isRequired: true,
      default: "SE",
      options: familyDescriptionOptions,
      hidden: true,
    },
    guardianmobile: {
      name: "Guardian Mobile Number",
      isRequired: true,
      placeholder: "Enter Guardian Mobile Number",
      validate: mobileRegex,
      hidden: true,
    },
    guardianRelationship: {
      name: "Guardian Relationship with Minor",
      type: "select",
      isRequired: true,
      options: relationshipOptions,
      hidden: true,
    },
    address1: {
      name: "Address1",
      isRequired: investortype.investorType === "minor" ? false : true,
      placeholder: "Enter Address",
      hidden: true,
    },
    address2: {
      name: "Address2",
      isRequired: investortype.investorType === "minor" ? false : true,
      placeholder: "Enter Address",
      hidden: true,
    },
    city: {
      name: "City",
      isRequired: investortype.investorType === "minor" ? false : true,
      placeholder: "Enter City",
      validate: nameRegex,
      hidden: true,
    },
    state: {
      name: "State",
      isRequired: investortype.investorType === "minor" ? false : true,
      placeholder: "Enter State",
      validate: nameRegex,
      hidden: true,
    },
    country: {
      name: "Country",
      isRequired: investortype.investorType === "minor" ? false : true,
      placeholder: "Enter Country",
      validate: nameRegex,
      hidden: true,
    },
  };

  const initialFormValues = {
    modeOfHolding: SINGLE_APPLICANT,
    kycCompleted_1: YES,
  };

  const allFieldsMax = getFieldList({
    ...getFieldsFromMap("", applicantSchema, MAX_APPLICANTS),
  });

  for (let f of allFieldsMax) {
    initialFormValues[f.key] = initialFormValues[f.key] || f.default || "";
  }

  const [formValues, setFormValues] = useState(initialFormValues);
  const [errors, setErrors] = useState({});

  const showJointHolders = formValues.modeOfHolding !== SINGLE_APPLICANT;
  const noOfApplicants = showJointHolders ? 3 : 1;

  const applicantFields = getFieldsFromMap(
    "",
    applicantSchema,
    noOfApplicants,
    (field, i, k) => {
      if (i > 1) {
        const pan2 = formValues[`pan_${i}`];
        const panNotFilled = !pan2 || errors[`pan_${i}`];
        if (k === "pan") {
          field.name =
            i === 2 ? "PAN of Joint Holder 1" : "PAN of Joint Holder 2";
          field.validate = validateSecondPan;
        } else if (panNotFilled) {
          field.hidden = true;
        }
        if (i > 2) {
          if (k == "pan") {
            if (formValues.pan_2 && !errors.pan_2) {
              field.hidden = false;
              field.validate = validateThirdPan;
            } else {
              field.hidden = true;
              field.validate = null;
            }
            field.isRequired = false;
          }
        }
      }
      const category = formValues[`category_${i}`];
      const nriFields = ["address1", "address2", "state", "country", "city"];
      const minorFields = [
        "guardianname",
        "guardianpan",
        "guardianemailFamily",
        "guardianemail",
        "guardianmobileFamily",
        "guardianmobile",
        "guardianmobileFamily",
        "guardianRelationship",
      ];
      if (category === "20") {
        const isNriField = nriFields.some((fieldName) => fieldName === k);
        if (!!isNriField) field.hidden = false;
      }
      if (investortype.investorType === "minor") {
        const isMinorFields = minorFields.some((fieldName) => fieldName === k);
        if (!!isMinorFields) field.hidden = false;
      }
    }
  );

  const validateField = async (field, value) => {
    const validate = field.validate;
    let isValid = true;
    let errorMessage = "";
    if (!value && field.isRequired && !field.hidden) {
      errorMessage = `${field.name} is required to proceed.`;
    } else if (typeof validate == "function") {
      field.key.includes("nom_email")
        ? (errorMessage = validate(field, value))
        : (errorMessage = validate(value));
    } else if (typeof validate == "object" && field.isRequired) {
      const validationRegex = validate;
      if (formValues.category_1 !== "20") {
        isValid = validationRegex.test(value || "");
      }
      if (isValid && field.key == "email_1") {
        isValid = value.includes(".");
      }
      if (
        isValid &&
        field.key === "countrycode_1" &&
        formValues.category_1 === "20" &&
        value === "+91"
      ) {
        isValid = false;
      }
    } else if (typeof validate == "object" && !!value) {
      const validationRegex = validate;
      isValid = validationRegex.test(value);
    }
    if (field.key.includes("email_1") && value.includes(" ")) {
      isValid = false;
    }

    if (!isValid) {
      errorMessage = `Please enter a valid ${field.name}`;
    }
    setFieldError(field.key, errorMessage);
    await $wait(10);
    if (errorMessage) {
      return { [field.key]: errorMessage };
    }

    if (!value && field.isRequired && !field.hidden) {
      errorMessage = `${field.name} is required to proceed.`;
    }
    if (typeof validate == "function") {
      field.key.includes("nom_email")
        ? (errorMessage = validate(field, value))
        : (errorMessage = validate(value));
    } else if (typeof validate == "object" && field.isRequired) {
      const validationRegex = validate;
      if (formValues.category_1 !== "20") {
        isValid = validationRegex.test(value || "");
      }
    } else if (typeof validate == "object" && !!value) {
      const validationRegex = validate;
      isValid = validationRegex.test(value);
    }
    if (!isValid) {
      errorMessage = `Please enter a valid ${field.name}`;
    }
    setFieldError(field.key, errorMessage);
    await $wait(10);
    if (errorMessage) {
      return { [field.key]: errorMessage };
    }
  };

  const applicantFieldList = getFieldList(applicantFields);

  const allFields = [...applicantFieldList];

  const removeJointHolderDetails = () => {
    try {
      const newFormValues = formValues;
      const jointHoldersFields = [...applicantFieldList];
      for (let f of jointHoldersFields) {
        if (["_2", "_3"].some((num) => f.key.includes(num))) {
          delete newFormValues[f.key];
        }
      }
      setFormValues(newFormValues);
    } catch (error) {
      console.error(error);
    }
  };

  const prefillFormValues = async () => {
    const { location } = props;
    const { state } = location;

    if (!!state && !!state.pan && !props.applicantparams.i_fname) {
      setIsLoading(true);
      const { pan } = state;
      try {
        const kycResponse = await props.getKycDetails({ pan });
        const { DtData } = kycResponse;
        const kycDetails = DtData[0];
        for (let key in kycDetails) {
          const val = kycDetails[key];
          if (!val) {
            key === "country"
              ? (kycDetails[key] = "India")
              : (kycDetails[key] = "");
          }
        }

        const { name1, gender, dob, email, mobile, app_cat } = kycDetails;
        const kycFormValues = {
          name_1: name1,
          pan_1: pan,
          dob_1:
            !!dob &&
            differenceInYears(
              new Date(),
              new Date(parseInt(dob.substr(6))),
              "MM/dd/yyyy"
            ) >= 18
              ? format(new Date(parseInt(dob.substr(6))), "MM/dd/yyyy")
              : "",
          email_1: email,
          gender_1: gender,
          mobile_1: mobile.trim(),
          category_1: app_cat,
          status_1: +app_cat === 11 ? "I" : +app_cat > 20 ? "N" : "",
        };

        setFormValues((prev) => {
          return { ...prev, ...kycFormValues };
        });
        setDisabledFields((prev) => {
          return {
            ...prev,
            pan_1: investortype.investorType != "minor" ? true : false,
            kycCompleted_1: true,
            status_1: true,
            // name_1: investortype.investorType != "minor" ? true : false,
          };
        });
      } catch (err) {
        setFormValues((prev) => {
          return {
            ...prev,
            pan_1: pan,
          };
        });

        setDisabledFields((prev) => {
          return {
            ...prev,
            pan_1: true,
            kycCompleted_1: true,
            status_1: true,
          };
        });
      } finally {
        setIsLoading(false);
      }
    }
  };
  const gotoEkyc = () => {
    props.history.replace(NEW_TRANSACTION_URL);
  };
  const checkReduxStore = async () => {
    const { applicantparams } = props;
    const {
      i_category,
      i_dob,
      i_email,
      i_email3,
      i_fname,
      i_invgender,
      i_mobileno,
      i_pangno,
      fEmailFlag,
      fMobileFlag,
      typeofinvestor,
      JHfEmailFlag1,
      JHfMobileFlag1,
      JHfEmailFlag2,
      JHfMobileFlag2,
      i_genMOH,
      i_pangno2,
      i_jholder1,
      i_invgender2,
      i_jh1dob,
      i_category2,
      i_mobileno2,
      i_pangno3,
      i_jholder2,
      i_email2,
      i_invgender3,
      i_jh2dob,
      i_category3,
      i_mobileno3,
      i_shnriadd1,
      i_shnriadd2,
      i_shnricity,
      i_shnristate,
      i_shnricountry,
      i_jhnriadd1,
      i_jhnriadd2,
      i_jhnricity,
      i_jhnristate,
      i_jhnricountry,
      i_nriadd1,
      i_nriadd2,
      i_nricity,
      i_nristate,
      i_nricountry,
      i_guardianname,
      i_guardianpan,
      i_guadianmobile,
      i_guardianemail,
      i_guardianEmailFlag,
      i_guardianMobileFlag,
      i_guardianrelationship,
    } = applicantparams;
    if (!!props.applicantparams.i_fname) {
      setFormValues({
        ...formValues,
        [`name_1`]: i_fname,
        [`pan_1`]: i_pangno,
        [`dob_1`]: i_dob,
        [`gender_1`]: i_invgender,
        [`email_1`]: i_email,
        [`mobile_1`]: i_mobileno,
        [`category_1`]: i_category,
        [`emailFamily_1`]: fEmailFlag,
        [`mobileFamily_1`]: fMobileFlag,
        [`modeOfHolding`]: i_genMOH === "1" ? "single" : "anyone",
        ...(!!i_pangno2 && {
          [`name_2`]: i_jholder1,
          [`pan_2`]: i_pangno2,
          [`dob_2`]: i_jh1dob,
          [`gender_2`]: i_invgender2,
          [`email_2`]: i_email2,
          [`mobile_2`]: i_mobileno2,
          [`category_2`]: i_category2,
          [`emailFamily_2`]: JHfEmailFlag1,
          [`mobileFamily_2`]: JHfMobileFlag1,
        }),
        ...(!!i_pangno3 && {
          [`name_3`]: i_jholder2,
          [`pan_3`]: i_pangno3,
          [`dob_3`]: i_jh2dob,
          [`gender_3`]: i_invgender3,
          [`email_3`]: i_email3,
          [`mobile_3`]: i_mobileno3,
          [`category_3`]: i_category3,
          [`emailFamily_3`]: JHfEmailFlag2,
          [`mobileFamily_3`]: JHfMobileFlag2,
        }),
        ...(i_category === "20" && {
          [`address1_1`]: i_nriadd1,
          [`address2_1`]: i_nriadd2,
          [`city_1`]: i_nricity,
          [`state_1`]: i_nristate,
          [`country_1`]: i_nricountry,
        }),
        ...(i_category2 === "20" && {
          [`address1_2`]: i_jhnriadd1,
          [`address2_2`]: i_jhnriadd2,
          [`city_2`]: i_jhnricity,
          [`state_2`]: i_jhnristate,
          [`country_2`]: i_jhnricountry,
        }),
        ...(i_category3 === "20" && {
          [`address1_3`]: i_shnriadd1,
          [`address2_3`]: i_shnriadd2,
          [`city_3`]: i_shnricity,
          [`state_3`]: i_shnristate,
          [`country_3`]: i_shnricountry,
        }),
        ...(typeofinvestor === "M" && {
          [`guardianname_1`]: i_guardianname,
          [`guardianpan_1`]: i_guardianpan,
          [`guardianmobile_1`]: i_guadianmobile,
          [`guardianemail_1`]: i_guardianemail,
          [`guardianemailFamily_1`]: i_guardianEmailFlag,
          [`guardianmobileFamily_1`]: i_guardianMobileFlag,
          [`guardianRelationship_1`]: i_guardianrelationship,
        }),
      });
      setInvestorType({
        investorType: typeofinvestor === "M" ? "minor" : "individual",
      });
    }
  };
  const firstRender = async () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    if (!!props.location.state) {
      props.storePan(props.location.state.pan);
    }
    await prefillFormValues();
    await checkReduxStore();
  };
  useEffect(() => {
    firstRender();
  }, []);
  const handleInvestor = async (e) => {
    setInvestorType({ investorType: e.target.value });
    if (e.target.value === "minor") {
      setFormValues((prev) => {
        return {
          ...prev,
          ["guardianpan_1"]: props.store_pan,
          ["guardianname_1"]: formValues.name_1,
          ["guardianemail_1"]: formValues.email_1,
          ["guardianmobile_1"]: formValues.mobile_1,
          [`modeOfHolding`]: SINGLE_APPLICANT,
          [`name_1`]: "",
          [`pan_1`]: "",
          [`dob_1`]: "",
          [`gender_1`]: "",
          [`email_1`]: "",
          [`mobile_1`]: "",
          [`category_1`]: "",
          [`emailFamily_1`]: "",
          [`mobileFamily_1`]: "",
        };
      });
    }
    setDisabledFields((prev) => {
      return {
        ...prev,
        pan_1:
          e.target.value === "individual" && formValues.pan_1.length === 10
            ? true
            : false,
      };
    });
  };
  const convertDateFormat = (originalDate) => {
    const [month, day, year] = originalDate.split("/");

    const convertedDate = `${day}/${month}/${year}`;

    return convertedDate;
  };
  const submit = async () => {
    try {
      setIsLoading(true);
      const errors = [];

      for (let field of allFields) {
        const error = await validateField(field, formValues[field.key]);
        if (error) {
          errors.push(error);
        }
      }
      const isValid = errors.filter((e) => !!e).length === 0;
      const getStatus = (category) => category === "20" ? "NRI" : "RI";
      const getInvStatus = (category) => !!category ? getStatus(category) : "";

      if (!!isValid) {
        const payload = {
          pan: formValues.pan_1,
          PanName: formValues.name_1,
          PanDOB: !!formValues.dob_1
            ? convertDateFormat(formValues.dob_1)
            : formValues.dob_1,
          folio: "",
          trType: "New",
          fund: "189",
          scheme: "",
          plan: "",
          guardianPan: formValues.guardianpan_1,
          guardianPanDOB: "",
          guardianPanName: formValues.guardianname_1,
          jointHolder1Pan: formValues.pan_2,
          jointHolder1PanName: formValues.name_2,
          jointHolder1PanDOB: !!formValues.dob_2
            ? convertDateFormat(formValues.dob_2)
            : formValues.dob_2,
          jointHolder2Pan: formValues.pan_3,
          jointHolder2PanName: formValues.name_3,
          jointHolder2PanDOB: !!formValues.dob_3
            ? convertDateFormat(formValues.dob_3)
            : formValues.dob_3,
            invStatus: getInvStatus(formValues.category_1),
            JH1_invStatus:getInvStatus(formValues.category_2),
            JH2_invStatus:getInvStatus(formValues.category_3),  

        };
        if (process?.env?.REACT_APP_API_URL?.includes("partner.bajajamc.com")) {
          const response = await props.checkPAN(payload);
          validateResponse(response);
        }
        const ApplicantDetails = {
          i_Ckyc1: formValues.kycCompleted_1,
          i_category: formValues.category_1,
          i_dob: formValues.dob_1,
          i_email: formValues.email_1,
          i_fname: formValues.name_1,
          i_invgender: formValues.gender_1,
          i_mobileno: formValues.countrycode_1 + formValues.mobile_1,
          i_pangno: formValues.pan_1,
          fEmailFlag: formValues.emailFamily_1,
          fMobileFlag: formValues.mobileFamily_1,
          typeofinvestor:
            investortype.investorType === "individual" ? "I" : "M",
          i_genMOH: formValues.modeOfHolding === "single" ? "1" : "4",
          country_code: formValues.countrycode_1,
          ...(formValues.category_1 === "20" && {
            i_nriadd1: formValues.address1_1,
            i_nriadd2: formValues.address2_1,
            i_nricity: formValues.city_1,
            i_nristate: formValues.state_1,
            i_nricountry: formValues.country_1,
          }),
          ...(formValues.category_2 === "20" && {
            i_jhnriadd1: formValues.address1_2,
            i_jhnriadd2: formValues.address2_2,
            i_jhnricity: formValues.city_2,
            i_jhnristate: formValues.state_2,
            i_jhnricountry: formValues.country_2,
          }),
          ...(formValues.category_3 === "20" && {
            i_shnriadd1: formValues.address1_3,
            i_shnriadd2: formValues.address2_3,
            i_shnricity: formValues.city_3,
            i_shnristate: formValues.state_3,
            i_shnricountry: formValues.country_3,
          }),

          ...(formValues.modeOfHolding === "anyone" &&
            formValues.pan_2.length === 10 && {
              i_pangno2: formValues.pan_2,
              i_jholder1: formValues.name_2,
              i_email2: formValues.email_2,
              JHfEmailFlag1: formValues.emailFamily_2,
              JHfMobileFlag1: formValues.mobileFamily_2,
              i_invgender2: formValues.gender_2,
              i_jh1dob: formValues.dob_2,
              i_category2: formValues.category_2,
              i_mobileno2: formValues.mobile_2,
              JHcountry_code1: formValues.countrycode_2,
            }),
          ...(formValues.modeOfHolding === "anyone" &&
            formValues.pan_3.length === 10 && {
              i_pangno3: formValues.pan_3,
              i_jholder2: formValues.name_3,
              i_email3: formValues.email_3,
              JHfEmailFlag2: formValues.emailFamily_3,
              JHfMobileFlag2: formValues.mobileFamily_3,
              i_invgender3: formValues.gender_3,
              i_jh2dob: formValues.dob_3,
              i_category3: formValues.category_3,
              i_mobileno3: formValues.mobile_3,
              JHcountry_code2: formValues.countrycode_3,
            }),
          ...(investortype.investorType === "minor" && {
            i_guardianname: formValues.guardianname_1,
            i_guardianpan: formValues.guardianpan_1,
            i_guadianmobile: formValues.guardianmobile_1,
            i_guardianemail: formValues.guardianemail_1,
            i_guardianEmailFlag: formValues.guardianemailFamily_1,
            i_guardianMobileFlag: formValues.guardianmobileFamily_1,
            i_guardianrelationship: formValues.guardianRelationship_1,
          }),
        };
        if (isValid) {
          props.storeApplicantParams(ApplicantDetails);
          props.history.push({
            pathname: "/new-investor-transaction/fatca-details",
          });
        } else {
          const id = Object.keys(errors[0])[0] + "Field";
          const element = document.getElementById(id);
          element.focus();
          setIsLoading(false);
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false); // Make sure to set isLoading to false in case of an error
      alert(error.message);
      console.error("Error occurred:", error);
    }
  };
  // End of Sumbit, thank you, visit again.

  function validateResponse(response) {
    setIsLoading(false);
    if (response.Transaction_allow === "N") {
      if (response.PASFlag === "N") {
        throw new Error(response.PASRemarks);
      }
      if (response.PANFlag === "N") {
        throw new Error(response.PANRemarks);
      }
      if (response.PANNameMatch === "N") {
        throw new Error("Entered Primary name does not match with PAN record");
      }
      if (response.JH1_panFlag === "N") {
        throw new Error(response.JH1_panRemarks);
      }
      if (response.JH2_panFlag === "N") {
        throw new Error(response.JH2_panRemarks);
      }
      if (response.G_panFlag === "N") {
        throw new Error(response.G_panRemarks);
      }
      if (response.JH1_PANNameMatch === "N") {
        throw new Error(
          "Entered Joint Holder 1 name does not match with PAN record"
        );
      }
      if (response.JH2_PANNameMatch === "N") {
        throw new Error(
          "Entered  Joint Holder 2 name name does not match with PAN record"
        );
      }
      if (response.G_PANNameMatch === "N") {
        throw new Error("Entered Guardian name does not match with PAN record");
      }
      if (response.PanDOBMatch === "N") {
        throw new Error("Entered Primary DOB does not match with PAN record");
      }
      if (response.JH1_PanDOBMatch === "N") {
        throw new Error(
          "Entered Joint Holder 1 DOB does not match with PAN record"
        );
      }
      if (response.JH2_PanDOBMatch === "N") {
        throw new Error(
          "Entered  Joint Holder 2 DOB name does not match with PAN record"
        );
      }
      if (response.G_PanDOBMatch === "N") {
        throw new Error("Entered Guardian DOB does not match with PAN record");
      }
    }
  }

  const setFieldValue = (field_key, value) => {
    setFormValues((values) => ({
      ...values,
      [field_key]: value,
    }));
  };

  const setFieldError = (field_key, errorMessage) => {
    setErrors((errors) => ({
      ...errors,
      [field_key]: errorMessage,
    }));
  };

  const handleChange = (field) => {
    return (e) => {
      const value =
        typeof e == "string"
          ? e
          : field.type === "date"
          ? format(new Date(e), "MM/dd/yyyy")
          : field.key.includes("pan")
          ? e.target.value.toUpperCase()
          : (e.target && e.target.value) || "";
      if (field.key.includes("category")) {
        let countryCode = "+91";
        const status = +value === 11 ? "I" : +value === 20 ? "N" : "";
        const key = field.key.replace("category", "status");
        setFieldValue(key, status);
        if (String(value) === "20") {
          countryCode = "";
        }
        const countryCodeKey = field.key.replace("category", "countrycode");
        setFieldValue(countryCodeKey, countryCode);
      }
      setFieldValue(field.key, value);
      validateField(field, value)
        .then((error) => {
          if (
            field.key.includes("pan") &&
            value &&
            value.length == 10 &&
            !error
          ) {
            const id = field.key + "Field";
            const element = document.getElementById(id);
            element.blur();
            getKycStatus(field)({ target: { value } });
          }
        })
        .catch((err) => {
          console.error(err);
          setFieldValue(field.key, "");
        });
    };
  };

  const handleBlur = (field) => {
    return async (e) => {
      const value =
        typeof e == "string" ? e : (e.target && e.target.value) || "";
      const error = await validateField(field, value);
      if (error) {
        setFieldValue(field.key, "");
      }
    };
  };

  const getKycStatus = (field) => async (e) => {
    const value = e.target.value;
    const n = field.key.split("_")[1];
    if (field.key != "guardianpan_1") {
      setIsLoading(true);
      try {
        const error = await validateField(field, value);

        if (error) {
          return;
        }

        const response = await props.checkKyc({
          fund: "189",
          userid: props.userId,
          i_pan: value,
        });
        const {
          DtData: [info],
        } = response;
        if (info.KYCBlock !== "N") {
          +n === 2 ? setDisplayModal1(true) : setDisplayModal2(true);
          setPreviouslyCheckedPAN((val) => ({ ...val, [field.key]: "" }));
          return;
        }
        const kycDetails = await props.getKycDetails({ pan: value });
        const { DtData } = kycDetails;
        const {
          name1,
          gender,
          app_pangno,
          app_occ,
          dob,
          email,
          mobile,
          app_cat,
        } = DtData[0];
        const kycFormValues = {
          [`name_${n}`]: name1 ? name1 : '',
          [`pan_${n}`]: app_pangno ? app_pangno : value,
          [`dob_${n}`]: !!dob ? 
             format(new Date(parseInt(dob.substr(6))), "MM/dd/yyyy") : 
            '',
          [`gender_${n}`]: gender ? gender : '',
          [`email_${n}`]: email ? email : '',
          [`mobile_${n}`]: mobile ? mobile : '',
          [`kyc_occupation_${n}`]: app_occ ? app_occ : '',
          [`category_${n}`]: app_cat ? app_cat : '',
          [`status_${n}`]: app_cat ? (+app_cat === 11 ? "I" : +app_cat > 20 ? "N" : '') : '',
        };

        setFormValues((prev) => {
          return {
            ...prev,
            ...kycFormValues,
          };
        });
        setDisabledFields((prev) => {
          return {
            ...prev,
            [`kycCompleted_${n}`]: true,
            [`status_${n}`]: true,
          };
        });
      } catch (error) {
        setFormValues((prev) => {
          return {
            ...prev,
            [`name_${n}`]: "",
            [`dob_${n}`]: "",
            [`email_${n}`]: "",
            [`mobile_${n}`]: "",
            [`kyc_occupation_${n}`]: "",
            [`category_${n}`]: "",
            [`status_${n}`]: "",
          };
        });

        setDisabledFields((prev) => {
          return {
            ...prev,
            [`kycCompleted_${n}`]: true,
            [`status_${n}`]: true,
          };
        });
      } finally {
        setIsLoading(false);
      }
    }
  };

  const isMinor = investortype.investorType == "minor";

  return (
    <>
      <CustomLoader display={isLoading} />
      <div className="d-flex align-items-center container-margin-first-investor ">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            fontFamily: "Rubik-Regular",
          }}
        >
          {/* <p className="font-weight-bold my-2 mb-0">Type of Investor:</p>
          <div style={{ marginBottom: 20 }}>
            <ChoiceFieldforinvestor
              value={investortype.investorType}
              options={investorOptions}
              onChange={(e) => handleInvestor(e)}
            />
          </div> */}

          {!isMinor && (
            <>
              <div className="input-field-container ">
                <div className="input-name" style={{ marginBottom: 0 }}>
                  Mode of Holding*
                </div>
                <FormControl component="fieldset">
                  <RadioGroup
                    aria-label="Search"
                    name="search"
                    value={formValues["modeOfHolding"]}
                    style={{ flexDirection: "row" }}
                    onChange={(e) => {
                      if (formValues.modeOfHolding !== e.target.value) {
                        removeJointHolderDetails();
                      }
                      setFieldValue("modeOfHolding", e.target.value);
                    }}
                  >
                    <div className="investor-radio-button">
                      <FormControlLabel
                        value="single"
                        control={
                          <Radio
                            className="investor-search-radio"
                            style={{ color: "#003d7b" }}
                          />
                        }
                        className="investor-formcontrol-label"
                        style={{ margin: 0 }}
                      />
                      <div className="investor-form-label">Single</div>
                    </div>
                    <div className="investor-radio-button">
                      <FormControlLabel
                        value="anyone"
                        control={
                          <Radio
                            className="investor-search-radio"
                            style={{ color: "#003d7b" }}
                          />
                        }
                        className="investor-formcontrol-label"
                        style={{ margin: 0 }}
                      />
                      <div className="investor-form-label">
                        Anyone (or) Surviour
                      </div>
                    </div>
                  </RadioGroup>
                </FormControl>
              </div>
            </>
          )}
        </div>
      </div>
      <CardComponent title="Investor Details">
        <div className="new-investor-container">
          {applicantFieldList.map((field) => {
            return (
              <React.Fragment key={field.key}>
                <AutoField
                  field={field}
                  value={formValues[field.key]}
                  error={errors[field.key]}
                  onChange={handleChange(field)}
                  onBlur={handleBlur(field)}
                  disabled={disabledFields[field.key]}
                  investorType={investortype.investorType}
                />
                {!!field.nextEmpty && <div className="p-2 " />}
              </React.Fragment>
            );
          })}
        </div>
        <KycNotDoneDialog
          open={displayModal1}
          close={() => {
            setFieldValue("pan_2", "");
            setDisplayModal1(false);
          }}
          continue={gotoEkyc}
        />
        <KycNotDoneDialog
          open={displayModal2}
          close={() => {
            setFieldValue("pan_3", "");
            setDisplayModal2(false);
          }}
          continue={gotoEkyc}
        />
      </CardComponent>

      <div className="d-flex align-items-center container-margin ">
        <button
          className="new-investor-button new-investor-active rounded ml-auto text-uppercase m-0 mr-0"
          onClick={submit}
          style={{ filter: "grayscale(1) opacity(0.4)" }}
          disabled={true}
        >
          Back
        </button>
        <button
          className="new-investor-button new-investor-active rounded text-uppercase m-0 ml-4"
          onClick={submit}
        >
          Proceed
        </button>
      </div>
    </>
  );
};

export default connect(
  ({ newinvestor, authReducer }) => {
    const { userId } = authReducer;
    const { applicantparams, store_pan } = newinvestor;
    return {
      applicantparams,
      store_pan,
      userId,
    };
  },
  {
    getCountriesList,
    checkPAN,
    getStatesList,
    storeApplicantParams,
    getKycDetails,
    checkKyc,
    getCitiesByState,
    getRelationShipList,
    storePan,
  }
)(InvestorDetails);

function ChoiceFieldforinvestor({ value, options, onChange }) {
  return (
    <div className="d-flex align-items-center ">
      {options.map((o, i) => {
        const isActive = o.value == value;
        const handleClick = () => {
          const newValue = o.value;
          onChange({ target: { value: newValue } });
        };
        const isFirst = i == 0;
        const isLast = i == options.length - 1;
        const radius = "6px";
        return (
          <div className={`d-flex align-items-center `} key={i}>
            <div
              className={`${
                isActive ? "bg-success text-white" : "text-success"
              } p-2
                  border border-success"
                  `}
              onClick={handleClick}
              style={{
                ...(isFirst && {
                  borderBottomLeftRadius: radius,
                  borderTopLeftRadius: radius,
                }),
                ...(isLast && {
                  borderBottomRightRadius: radius,
                  borderTopRightRadius: radius,
                }),
              }}
            >
              {o.name}
            </div>
          </div>
        );
      })}
    </div>
  );
}
